import { AxiosRequestConfig } from 'axios'

import { CreateCampaignEmailPayload, UpdateCampaignEmailData } from './campaignEmailsTypes'

const createCampaignEmail = (payload: CreateCampaignEmailPayload): AxiosRequestConfig => ({
  url: '/campaign-emails',
  method: 'POST',
  data: { campaignEmail: payload },
})

const updateCampaignEmail = (data: UpdateCampaignEmailData): AxiosRequestConfig => ({
  url: `/campaign-emails/${data.id}`,
  method: 'PUT',
  data: { campaignEmail: data.payload },
})

const getCampaignEmail = (id: number): AxiosRequestConfig => ({
  url: `/campaign-emails/${id}`,
  method: 'GET',
})

export { createCampaignEmail, updateCampaignEmail, getCampaignEmail }
